import 'p5/lib/addons/p5.dom';
import 'p5/lib/addons/p5.sound';
import * as firebase from 'firebase';
import map from 'lodash/map';
import sortBy from 'lodash/orderBy';
import getPitch from './pitch-detection';
import Promise from 'bluebird';
import p5 from 'p5';
import * as axios from 'axios';

import {drawWaterColorBrush} from './watercolor';
import frequencyToColor from './frequency-to-color';
import colorAlpha from './color-alpha';

const app = firebase.initializeApp({
  databaseURL: 'https://yamadapc.firebaseio.com',
});

let i = 0;

export default function sketch(p) {
  let minLat = -23.906776;
  let minLng = -46.812373;
  let maxLat = -23.3884855;
  let maxLng = -46.366144875;
  let dataKeys = [];
  let data = {};
  let drawn = {};
  const colors = {};

  axios.get('https://yamadapc.firebaseio.com/positions.json').then(res => {
    data = res.data;
    dataKeys = Object.keys(data);
    minLat = Infinity;
    minLng = Infinity;
    maxLat = -Infinity;
    maxLng = -Infinity;

    // const LIMIT = 300000;
    for (let i = 0; i < dataKeys.length; i++) {
      const [lat, lng] = data[dataKeys[i]].l;
      if (lat < minLat) {
        minLat = lat;
      }
      if (lng < minLng) {
        minLng = lng;
      }
      if (lat > maxLat) {
        maxLat = lat;
      }
      if (lng > maxLng) {
        maxLng = lng;
      }
    }

    console.log('Sorting...')
    const dataPrime = sortBy(
      map(data, (item, lineCodeAndTs) => {
        lineCodeAndTs = lineCodeAndTs.split(':');
        return {
          item,
          lineCode: lineCodeAndTs[0],
          timestamp: lineCodeAndTs[1],
          idAndTimestamp: lineCodeAndTs[0] + lineCodeAndTs[1],
        };
      }),
      'idAndTimestamp'
    ); //.slice(0, LIMIT);
    // console.log(dataPrime)

    Promise.map(
      dataPrime,
      // .slice(0, 100000),
      ({lineCode, item}) => {
        return Promise.delay(50).then(() => {
          // return app
          //   .database()
          //   .ref('positions/' + d)
          //   .once('value', v => {
          //     data[d] = v.val();
          // console.log(minLat, minLng, maxLat, maxLng)
          // dataKeys.push(d);

          const [lat, lng] = item.l;

          if (drawn[lat + ':' + lng]) {
            return;
          }

          drawn[lat + ':' + lng] = true;

          if (!colors[lineCode]) {
            colors[lineCode] = randomColor();
          }
          p.stroke(colors[lineCode]);
          p.fill(colors[lineCode]);
          p.ellipse(latToPixel(lat), lngToPixel(lng), 3, 3);
          // });
        });
      },
      {
        concurrency: 30,
      },
    );
  });

  function randomColor() {
    function c() {
      return p.random(0, 255);
    }
    return p.color(c(), c(), c());
  }

  // P5.sound Variables
  let source, fft, lowPass, amplitude;

  let drawState = {};
  const drawConfiguration = {
    brushName: 'Water Color',
    scaleFactor: 800,
    background: 255,
  };

  p.myCustomRedrawAccordingToNewPropsHandler = function myCustomRedrawAccordingToNewPropsHandler(
    props,
  ) {
    if (props.slider1Value != null) {
      drawConfiguration.scaleFactor = props.slider1Value;
    }

    if (
      props.background != null &&
      props.background !== drawConfiguration.originalBackground
    ) {
      p.background(props.background);
      drawConfiguration.originalBackground = props.background;
      drawConfiguration.background = colorAlpha(p, props.background, 0.001);
    }

    if (props.brushName != null) {
      drawConfiguration.brushName = props.brushName;
    }

    if (props.holdDraw != null) {
      drawConfiguration.holdDraw = props.holdDraw;
    }

    if (props.colors != null) {
      drawConfiguration.colors = props.colors;
    }
  };

  p.setup = function setup() {
    console.log('creating canvas');
    p.createCanvas(p.windowWidth, p.windowHeight);
    p.noFill();

    // uncomment me to use mic
    source = new p5.AudioIn();
    source.start();

    // source.play(); // comment me to use mic

    amplitude = new p5.Amplitude();
    amplitude.setInput(source);

    lowPass = new p5.LowPass();
    lowPass.disconnect();
    source.connect(lowPass);

    fft = new p5.FFT();
    fft.setInput(lowPass);

    p.background(0);

    drawConfiguration.background = colorAlpha(p, 255, 0.001);
  };

  function latToPixel(lat) {
    return p.map(lat, minLat, maxLat, 0, p.width);
  }

  function lngToPixel(lng) {
    return p.map(lng, minLng, maxLng, 0, p.height);
  }

  let storedEllipses = [];
  let level,
    timeDomain,
    freq,
    fToColor = {};
  // let translateX = 0;

  p.draw = function draw() {
    p.background(colorAlpha(p, 0, 0.008));

    p.noFill();

    level = amplitude.getLevel();

    timeDomain = fft.waveform(1024, 'float32');
    freq = getPitch(p, timeDomain);
    fToColor = frequencyToColor(p, freq, level, drawConfiguration);
    const {color, noteName, targetFrequency} = fToColor;
    p.onChange &&
      p.onChange({
        frequency: freq,
        spectrumColor: color,
        targetFrequency,
        noteName,
        level,

        drawConfiguration,
        slider1: {
          value: drawConfiguration.scaleFactor,
          max: 4500,
          min: 0,
          label: 'Brush Scale',
        },
      });

    // dataKeys.forEach(k => {
    //   const [lat, lng] = data[k].l;

    //   if (drawn[lat + ':' + lng]) {
    //     return;
    //   }

    //   drawn[lat + ':' + lng] = true;

    //   p.fill('black');
    //   p.ellipse(latToPixel(lat), lngToPixel(lng), 3, 3);
    // });
  };

  p.touchStarted = function touchStarted() {
    p.getAudioContext().resume();
  };
}



// WEBPACK FOOTER //
// ./src/sketches/map.js